import React from 'react';
import { motion } from 'framer-motion';
export function Mentoring() {
  return <section className="py-24 md:py-32 bg-ink-light relative border-y border-white/5" id="mentoria" data-id="element-148">
      <div className="container mx-auto px-6" data-id="element-149">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-150">
          <motion.div className="lg:col-span-5 lg:order-2" initial={{
          opacity: 0,
          x: 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-151">
            <div className="relative aspect-[4/5] max-w-md mx-auto lg:ml-auto" data-id="element-152">
              <img src="https://cdn.magicpatterns.com/uploads/mJrcWYZu3kE9dZgEkf7KYn/ChatGPT_Image_18_may_2026,_10_15_41.png" alt="Freddy en sesión de mentoría" className="w-full h-full object-cover border border-white/10" data-id="element-153" />
              <div className="absolute -inset-4 border border-gold/20 -z-10 translate-x-4 translate-y-4" data-id="element-154"></div>
            </div>
          </motion.div>

          <motion.div className="lg:col-span-7 lg:order-1 lg:pr-12" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-155">
            <span className="text-gold tracking-[0.2em] text-xs md:text-sm font-semibold uppercase mb-4 block" data-id="element-156">
              El Proceso
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-ivory-bright mb-8" data-id="element-157">
              ¿Qué es la Mentoría Estratégica{' '}
              <span className="font-sans font-light" data-id="element-158">1 a 1</span>?
            </h2>

            <div className="space-y-6 text-muted font-light leading-relaxed text-lg mb-12" data-id="element-159">
              <p data-id="element-160">
                Es una sesión personalizada de acompañamiento donde trabajaremos
                juntos para identificar qué áreas están drenando hoy tu
                tranquilidad emocional, tus relaciones, tu enfoque o tu
                propósito.
              </p>
              <p data-id="element-161">El objetivo no es darte frases motivacionales.</p>
              <p className="text-ivory" data-id="element-162">El objetivo es ayudarte a:</p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4" data-id="element-163">
                {['Recuperar claridad', 'Ordenar tu vida emocional', 'Fortalecer tu mentalidad', 'Reconstruir dirección', 'Diseñar un nuevo punto de partida'].map((item, i) => <li key={i} className="flex items-center gap-3 text-ivory/80" data-id="element-164">
                    <div className="w-1.5 h-1.5 bg-gold rounded-full" data-id="element-165"></div>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="pt-8 border-t border-gold/20" data-id="element-166">
              <p className="font-serif text-3xl md:text-4xl text-ivory-bright" data-id="element-167">
                NO ES SUERTE.
                <br data-id="element-168" />
                <span className="text-gold italic" data-id="element-169">ES ESTRATEGIA.</span>
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}